import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { CSVDataService } from '@app/export/CSVDataService';
import { InstitutionsService } from '@app/services/institutions/institutions.service';
import { StatisticsService } from '@app/services/Statistics/Statistics.service';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-attendance-per-institution-per-month',
  templateUrl: './attendance-per-institution-per-month.component.html'
})

export class AttendancePerInstitutionPerMonthComponent implements OnInit {
  form;
  
  showSpinner = false;
  antal;
  antalInst = 0;
  rowno = 0;
  response;
  result: any[] = [];
  years: any[] = [];
  items: MenuItem[];

  constructor(private fb: FormBuilder,
    private router: Router,
    private datePipe: DatePipe,
    private statisticsService: StatisticsService,
    private institutionService: InstitutionsService) {
    this.router.events.subscribe(x => {
      if (x instanceof NavigationEnd) {
        this.clearReport();
      }
    });
  }

  ngOnInit() {
    this.form = this.fb.group({
      lodges: ['', ''],
      camps: ['', ''],
      institutions: ['', ''],
      parentInstitutionId: ['', ''],
      selectedFilter: ['', ''],
      selectedYears: ['', ''],
      districts: ['', '']
    });
    this.setItems();
  }

  setItems() {
    this.items = [
      {
        label: 'Excel',
        icon: 'fa fa-file-excel',
        command: () => this.exportToCSV()
      }
    ];
  }

  exportToCSV() {
    // tslint:disable-next-line:max-line-length
    const firstrow =
      'Institution;Distrikt;Mötestyp;År;Månad;Antal möten;Antal egnas besök i annan inst.;Antal gäster från annan institution;Egna närvarande;Antal medlemmar i logen vid årets slut';
    const datum = this.datePipe.transform(new Date(), 'yy-MM-dd');
    const filnamn = 'NärvaroPerInstiutionPerMånad_' + datum;
    let data: any[] = [];
    this.result.forEach(x => {
      const row = {
        col1: x.name,
        col2: x.district,
        col3: x.meetingType,
        col4: x.year,
        col5: x.month,
        col6: x.numberOfMeetings,
        col7: x.numberOfOwnMembersInOtherInstitutions,
        col8: x.numberOfGuestsFromOtherInstitutions,
        col9: x.attendance,
        col10: x.membersAtEndOfYear
      };
      data.push(row);
    });
    CSVDataService.exportToCsv(filnamn + '.csv', data, firstrow);
  }

  clearReport() {
    this.response = null;
    this.form?.reset();
    this.years = [];
    this.result = [];
    this.antalInst = 0;
  }

  createReport(evt) {
    this.result = [];
    const statisticsInput = {
      generalStatisticsReportInputModel: evt.value
    };
    this.antalInst = 0;
    if (statisticsInput.generalStatisticsReportInputModel.institutions.length > 0 &&
      statisticsInput.generalStatisticsReportInputModel.selectedFilter !== '4') {
      this.statisticsService.GetAttendanceStatisticsPerInstitutionPerMonthReport(statisticsInput).subscribe(resp => {
        if (resp) {
          this.result = resp;
          this.setItems();
          this.showSpinner = false;
        }
      });
    } else if (statisticsInput.generalStatisticsReportInputModel.lodges !== null) {
      this.institutionService
        .GetAllInstitutionsByInstitutionType(statisticsInput.generalStatisticsReportInputModel.lodges).subscribe(x => {
          if (x) {
            this.antal = x.length;
          }
          x.forEach(i => {
            this.rowno++;
            const idn = [];
            idn.push(i);
            statisticsInput.generalStatisticsReportInputModel.selectedFilter = '3';
            statisticsInput.generalStatisticsReportInputModel.lodges = null;
            statisticsInput.generalStatisticsReportInputModel.institutions = idn;
            this.getResultForInstitution(statisticsInput);
          });
        });
    } else if (statisticsInput.generalStatisticsReportInputModel.selectedFilter === '4') {
      this.institutionService
        .GetAllInstitutionIDsFromDistrict(statisticsInput.generalStatisticsReportInputModel.districts[0]).subscribe(
          x => {
            if (x) {
              this.antal = x.length;
              x.forEach(i => {
                this.rowno++;
                const idn = [];
                idn.push(i);
                statisticsInput.generalStatisticsReportInputModel.selectedFilter = '3';
                statisticsInput.generalStatisticsReportInputModel.camps = null;
                statisticsInput.generalStatisticsReportInputModel.institutions = idn;
                this.getResultForInstitution(statisticsInput);
              });
            }
            this.showSpinner = false;
          });
      this.showSpinner = false;
    } else if (statisticsInput.generalStatisticsReportInputModel.camps !== null) {
      this.institutionService
        .GetAllInstitutionsByInstitutionType(statisticsInput.generalStatisticsReportInputModel.camps).subscribe(x => {
          if (x) {
            this.antal = x.length;
            x.forEach(i => {
              this.rowno++;
              const idn = [];
              idn.push(i);
              statisticsInput.generalStatisticsReportInputModel.selectedFilter = '3';
              statisticsInput.generalStatisticsReportInputModel.camps = null;
              statisticsInput.generalStatisticsReportInputModel.institutions = idn;
              this.getResultForInstitution(statisticsInput);
            });
            this.showSpinner = false;
          }
        });
    }
    this.showSpinner = false;
  }

  async getResultForInstitution(statisticsInput) {
    await this.statisticsService.GetAttendanceStatisticsPerInstitutionPerMonthReport(statisticsInput).subscribe(resp => {
      if (resp[0]) {
        this.antalInst++;
        resp.forEach(i => {
          this.result.push(i);
        });
      } else {
        this.antal--;
      };
    });
  }
}

